import Vue from 'vue'
import Vuex from 'vuex'

// modules
import shop from './modules/shop'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        shop
    },
    // state: {
    //     a: 1
    // },
    mutations: {

    },
    getters: {

    },
    actions: {
        init({ dispatch }, data: {token: string}) {
            console.log('arguments', arguments)
            return dispatch('shop/init', data)
        }
    }
})

export default store

export function useStore() {
    return store
}
